/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  paymetric-actions.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Sep 19, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            : Deepthi Bachu
 * On            : Sep 25 2019
 * Description   : ASDS-1285
 *
 * By            	: Madhu Gali - H175591
 * On            	: Oct 10, 2019
 * Description   : ASDS-1476
 *
 * By            : H422335
 * On            : Oct 10 2020
 * Description   : ASDS-3035 API Migration to new Forge API
 ******************************************************************************/

import Action from './Action';
import { isValueUndefined } from '../../../../utils/util';
import { CheckoutServiceURL } from "../../constants/checkout-constants";
import API from '../../API/api';
import CheckoutActionConstants from '../../constants/checkoutActionConstants';
import { logError } from '../../../../utils/console-utility';
import ShippingBillingActions from './shipping-billing-actions';
import { handleResponse } from 'modules/checkout/API/apiUtils';

class PaymetricActions extends Action {
    /**
     * @author H175591
     * @returns {(dispatch) => Promise<void>}
     * @description: This method details with returning the Paymetric UI response.
     */
    static getPaymetricURL() {
        return async (dispatch) => {
            const URL: string = CheckoutServiceURL.PAYMETRIC_UI_URL;
            dispatch(PaymetricActions.togglePaymetricServiceStatus());

            dispatch(ShippingBillingActions.toggleEnableReviewOrderBtnStatus(true));
            await API.get(URL)
                .then((response) => {
                    const data = handleResponse(response);
                    dispatch(PaymetricActions.retrievePaymetricData(data));
                    dispatch(ShippingBillingActions.toggleEnableReviewOrderBtnStatus(false));
                })
                .catch(error => {
                    logError('Error fetching and parsing data', error);
                    dispatch(PaymetricActions.hasError(true));
                });
        };
    }

    /**
     * ASDS-1476
     * @description Action creator for handling error in CC loading
     * @param flag
     */
    static hasError(flag) {
        return {
            type: CheckoutActionConstants.HAS_ERROR,
            payload: {
                response: flag,
            }
        };
    }

    /**
     * @description Action creator for retrieveing paymetric response.
     * @param response
     */
    static retrievePaymetricData(response) {
        return {
            type: CheckoutActionConstants.SET_PAYMETRIC_URL,
            payload: {
                response: isValueUndefined(response) ? null : response.paymetric || null
            }
        };
    }

    /**
     * @description Action creator for toggling service call.
     */
    static togglePaymetricServiceStatus() {
        return {
            type: CheckoutActionConstants.GET_PAYMETRIC_URL,
            payload: {}
        };
    }

    /**
     * @description: Increments the count for CC Section loading
     * JIRA ID: 1285
     */
    static incrementCount() {
        return (dispatch, getState) => {
            const count = getState().paymetricData.count;
            dispatch({
                type: CheckoutActionConstants.INCREMENT_CC_LOAD_COUNT,
                payload: {
                    count: count + 1
                }
            })
        };
    }

    /**
     * @description: Resets the count for CC Section loading
     * JIRA ID: 1285
     */
    static resetCCLoadCount() {
        return (dispatch) => {
            dispatch({
                type: CheckoutActionConstants.RESET_CC_LOAD_COUNT,
                payload: {
                    count: 0,
                }
            });
        };
    }
}

export default PaymetricActions;